import { render, staticRenderFns } from "./OnlinePlayer.vue?vue&type=template&id=a9568564&scoped=true&"
import script from "./OnlinePlayer.vue?vue&type=script&lang=js&"
export * from "./OnlinePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9568564",
  null
  
)

export default component.exports